import React, { useEffect, useState } from 'react';
import { Grid, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const TestimonialWidget = () => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  useEffect(() => {
    // Load the iframe resizer script
    const script = document.createElement('script');
    script.src = 'https://testimonial.to/js/iframeResizer.min.js';
    script.onload = () => {
      // Initialize iframe resizer after script loads
      if (window.iFrameResize) {
        window.iFrameResize({log: false, checkOrigin: false}, '#testimonialto-itaca-tag-all-light-animated');
      }
    };
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  // Build the iframe URL based on device type
  const getIframeUrl = () => {
    const baseUrl = 'https://embed-v2.testimonial.to/w/itaca';
    const params = new URLSearchParams({
      theme: 'light',
      horizShadowColor: 'ffffff',
      hideDate: 'on',
      tag: 'all',
      cc: 'off'
    });

    if (isMobile) {
      // Mobile: no animation, vertical layout
      params.set('animated', 'off');
      params.set('horizontal', 'off');
      params.set('rows', '3');
    } else {
      // Desktop: animation, horizontal layout
      params.set('animated', 'on');
      params.set('horizontal', 'on');
      params.set('speed', '1');
      params.set('rows', '1');
    }

    return `${baseUrl}?${params.toString()}`;
  };

  return (
    <div style={{ 
      marginTop: '50px',
      width: '100%'
    }}>
      <Title 
        level={2}
        style={{ 
          textAlign: 'center',
          marginBottom: '0px'
        }}
      >
        {t('testimonial_widget.title')}
      </Title>
      <iframe 
        id='testimonialto-itaca-tag-all-light-animated' 
        src={getIframeUrl()}
        style={{ border: 'none', overflow: 'hidden' }}
        width="100%"
        title="Customer Testimonials"
      />
    </div>
  );
};

export default TestimonialWidget; 